import React from "react";
import Button from "../../assets/images/backgrounds/submit_button.png";

import abcfLogo from "../../assets/images/abcf-logo.jpeg";

import "./style.css";

export default function ConsentScreen({setGameConsent}) {
  return (
    <>
      <div className="container">
        <img className="abcf-logo" src={abcfLogo} alt="logo-aditya-birla" />
        <p>
          ABFL invites you to play this exciting short game, that will take less
          than 3 mins of your time and can be played from anywhere! We wish to
          understand you better so that we can provide you services and
          offerings that suit you best. Start playing and have fun!
        </p>

        <div
          className="continue_button"
          onClick={() => {
            setGameConsent(true);
          }}
        >
          <img src={Button} alt="button_image" className="button_image" />
          <div type="button" className="button_text">
            Continue to Game
          </div>
        </div>
      </div>
    </>
  );
}
